import FeedbackUpload from 'pages/Reports/sections/Upload/FeedbackUpload/FeedbackUpload';

export default FeedbackUpload;
